import React from 'react';
import { Link } from 'react-router-dom';
import './MediaCenterHero.css';
import graphicImg from '../../assets/images/stats-hero-graphic.png'; // Reuse graphic
const MediaCenterHero = () => {
return (
<section className="media-center-hero-section">
<div className="media-center-hero-content">
<h1>CRISHI media center</h1>
<p>Turning complex market analysis into simple, impactful visual stories.</p>
<div className="media-center-hero-buttons">
<a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer"><button className="cta-button primary">Subscribe to YouTube Channel</button></a>
<Link to="/signup"><button className="cta-button secondary-outline">Book a demo</button></Link>
</div>
</div>
<div className="media-center-hero-graphic"><img src={graphicImg} alt="Media Graphic" /></div>
</section>
);
};
export default MediaCenterHero;